module.exports = function() {
	throw new Error("define cannot be used indirect");
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/webpack/buildin/amd-define.js
// module id = 806
// module chunks = 0